export default {
      id: "common__email-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__email",
      toString: function () {
        return this.url;
      }
    }